/** Layout applicatif : barre latérale de navigation + bascule de thème. */
import {
  Apple,
  BarChart3,
  BookOpen,
  Database,
  Droplet,
  Dumbbell,
  Flame,
  Home,
  type LucideIcon,
  Moon,
  NotebookPen,
  Salad,
  Settings,
  Sun,
  TrendingUp,
} from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { NetworkErrorBanner } from '@/components/NetworkErrorBanner';
import { useAuth } from '@/lib/auth';
import { useTheme } from '@/theme/ThemeContext';

const LINKS: { to: string; label: string; icon: LucideIcon; end: boolean }[] = [
  { to: '/', label: 'Accueil', icon: Home, end: true },
  { to: '/poids', label: 'Poids', icon: TrendingUp, end: false },
  { to: '/calories', label: 'Calories', icon: Flame, end: false },
  { to: '/macros', label: 'Macros', icon: Salad, end: false },
  { to: '/hydratation', label: 'Hydratation', icon: Droplet, end: false },
  { to: '/sport', label: 'Sport', icon: Dumbbell, end: false },
  { to: '/analyse', label: 'Analyse', icon: BarChart3, end: false },
  { to: '/journal', label: 'Journal', icon: NotebookPen, end: false },
  { to: '/foods', label: 'Aliments', icon: Apple, end: false },
  { to: '/data', label: 'Données', icon: Database, end: false },
  { to: '/annexes', label: 'Annexes', icon: BookOpen, end: false },
  { to: '/profile', label: 'Profil', icon: Settings, end: false },
];

export function Layout() {
  const { logout, user } = useAuth();
  const { theme, toggle } = useTheme();

  return (
    <div className="app-shell">
      <nav className="sidebar">
        <div className="brand">
          K<span>CAL</span>
        </div>
        {LINKS.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            <Icon size={18} aria-hidden="true" />
            {label}
          </NavLink>
        ))}
        <div className="spacer" />
        <button type="button" className="ghost" onClick={toggle} style={{ marginBottom: '0.5rem' }}>
          {theme === 'dark' ? (
            <Sun size={16} aria-hidden="true" />
          ) : (
            <Moon size={16} aria-hidden="true" />
          )}
          {theme === 'dark' ? 'Clair' : 'Sombre'}
        </button>
        <span className="muted" style={{ fontSize: '0.75rem', padding: '0 0.5rem' }}>
          {user?.email}
        </span>
        <button type="button" className="ghost" onClick={logout}>
          Déconnexion
        </button>
      </nav>
      <main className="main">
        <NetworkErrorBanner />
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
